import { TextCodes } from '@api/types/translation/TextCodes';
import DeleteIcon from '@mui/icons-material/Delete';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { t } from '@translations';

type ProductRequestDeleteProps = {
  handleDelete: () => void;
};

export const ProductRequestDelete: React.FC<ProductRequestDeleteProps> = ({
  handleDelete,
}: ProductRequestDeleteProps) => {
  return (
    <Tooltip title={t(TextCodes.Base.Delete)} placement='top'>
      <IconButton onClick={handleDelete}>
        <DeleteIcon fontSize='inherit' />
      </IconButton>
    </Tooltip>
  );
};
